import { ComponentProps, useMemo } from "react";

import { deserializeHtmlToRichTextDocument } from "./editor/htmlSerializer";
import RichTextRenderer from "./RichTextRenderer";

type Props = Omit<ComponentProps<typeof RichTextRenderer>, "children" | "document" | "markdown"> & {
    html: string;
};

export const HtmlRichTextRenderer = ({ html, ...props }: Props) => {
    const document = useMemo(() => deserializeHtmlToRichTextDocument(html), [html]);

    return <RichTextRenderer {...props} document={document} />;
};
